import React from "react";

function SvgContact(props) {
    return (
        <svg
            id="technorati-svgrepo-com_svg__Layer_1"
            x={0}
            y={0}
            viewBox="0 0 495 495"
            xmlSpace="preserve"
            height="5vh"
            color="#fff"
            {...props}
        >
            <style>{".technorati-svgrepo-com_svg__st1{fill:#fff}"}</style>
            <path fill="#fff" d="M247.5 0v40H455v415H247.5v40H495V0z" />
            <path
                className="technorati-svgrepo-com_svg__st1"
                d="M40 455V40h207.5V0H0v495h247.5v-40z"
            />
            <g id="technorati-svgrepo-com_svg__y4D0PD_tif">
                <path
                    className="technorati-svgrepo-com_svg__st1"
                    d="M398.3 163v168.9c-28.2-30.8-56.4-61.6-84.8-92.6.4-.5.7-.9 1-1.2 27.4-24.7 54.9-49.4 82.3-74.1.5-.3 1-.7 1.5-1zM384 150.9c-45.5 40.9-90.6 81.5-135.9 122.3-45.2-40.7-90.3-81.3-135.9-122.3H384z"
                />
                <path
                    className="technorati-svgrepo-com_svg__st1"
                    d="M385.4 345.2H110.8c28.8-31.5 57.1-62.5 85.7-93.8 5.4 4.9 10.6 9.5 15.9 14.2 11.1 10 22.2 20 33.3 30.1 1.9 1.7 3 1.8 5 0 15.5-14.1 31-28.1 46.6-42.1.8-.7 1.6-1.4 2.6-2.3 28.4 31.3 56.7 62.4 85.5 93.9zM182.8 239.1c-28.2 30.8-56.2 61.5-84.6 92.5V163c28.4 25.5 56.4 50.7 84.6 76.1z"
                />
            </g>
        </svg>
    );
}

export default SvgContact;



// WEBPACK FOOTER //
// ./src/images/svg/SvgContact.jsx